<style lang="scss" scoped>
.m-index {
	width: 100%;
	height: 100%;
	overflow: auto;
}
.container {
	position: relative;
	z-index: 0;
	width: 100%;
	background: #0c172d;
	.index-image-bg {
		width: 100%;
	}
	.index-logo {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 4vh;
		margin: 0 auto;
		width: auto;
		height: 35vh;
    	padding-left: 30px;
	}
	.video-btn {
		position: absolute;
		bottom: 17vh;
		right: 18%;
		width: auto;
		height: 14vh;
	}
}
.video-block {
	position: fixed;
	z-index: 100;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(1, 1, 1,  0.5);
	display: flex;
	justify-content: center;
	align-items: center;
}
.right-content {
	position: absolute;
	right: 0;
	bottom: 9vh;
	overflow: auto;
	text-align: center;
	.index-nav {
		position: relative;
		overflow: auto;
		.index-nav-bg {
			height: 30vh;
			width: auto;
		}
		.nav-items {
			position: absolute;
			top: 0;
			width: 100%;
			padding-top: 2vh;
		}
		.nav-item {
			color: #ffeeca;
			line-height: 5vh;
			transform: scale(0.9);
			padding-left: 5px;
		}
	}
	.index-handle {
		position: relative;
		height: 60px;
		overflow: hidden;
		.index-handle1 {
			position: absolute;
			height: 100%;
			top: 0;
			left: 10px;
			animation:animation1 10s linear infinite;
		}
		@keyframes animation1 {
			0%{ opacity: 0.4; }
			20%{ opacity: 0.6; }
			40%{ opacity: 0.8; }
			50%{ opacity: 1; }
			70%{ opacity: 1; }
			80%{ opacity: 0.8; }
			90%{ opacity: 0.6; }
			100%{ opacity: 0.4; }
		}
		.index-handle2 {
			position: absolute;
			height: 100%;
			top: 0;
			left: 10px;
			animation:animation2 40s linear infinite;
		}
		@keyframes animation2 {
			0%{ transform: rotate(0deg); }
			100%{ transform: rotate(360deg); }
		}
		.words {
			position: absolute;
			top: 5px;
			left: 14px;
			width: 58px;
			height: 52px;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			color: #ffeeca;
			padding: 6px;
			letter-spacing: 3px;
		}
	}
}
.footer {
	width: 100%;
	text-align: center;
	color: #8d7464;
	line-height: 20px;
	background: #0c172d;
	font-size: 12px;
	color: #ffffff;
	padding-bottom: 10px;
	overflow: auto;
	.follow {
		display: flex;
		justify-content: space-around;
		height: 90px;
		padding: 20px 10% 0 10%;
		.follow-item {
			width: auto;
			height: 65px
		}
	}
	.word {
		transform: scale(0.9);
	}
	.footer-logo {
		margin-bottom: 5px;
	}
}
.QQ-block {
	width: 60px;
  	height: 67px;
	img {
		width: 85%;
	}
	span {
		display: block;
    line-height: 0;
    font-size: 14px;
	}
}
</style>

<template>
	<div class="m-index">
		<div class="container">
			<img v-show="imageOrVideo == '2'" class="index-image-bg" :src="indexBg" alt="">
			<video v-show="imageOrVideo == '1'" class="index-image-bg" :src="indexBg"></video>
			<img class="index-logo" :src="indexLogo" alt="">
			<img v-show="showVideoBtn" @click="showVideo" class="video-btn" src="../../assets/mobile/video-btn.png" alt="">
			<div class="right-content">
				<!-- 首页导航 -->
				<div class="index-nav">
					<img class="index-nav-bg" src="../../assets/mobile/index-nav.png" alt="">
					<div class="nav-items">
						<router-link :to="{name: 'm-experience'}"><div class="nav-item">世界见闻</div></router-link>
						<router-link :to="{name: 'm-role'}"><div class="nav-item">羁绊主角</div></router-link>
						<router-link :to="{name: 'm-characteristic'}"><div class="nav-item">世界特色</div></router-link>
						<router-link :to="{name: 'm-impression'}"><div class="nav-item">声色印象</div></router-link>
						<router-link :to="{name: 'm-viewpoint'}"><div class="nav-item">世界观</div></router-link>
					</div>
				</div>
				<!-- 预约 -->
				<div @click="goHandle" class="index-handle">
					<img class="index-handle1" src="../../assets/mobile/index-handle2.png" alt="">
					<img class="index-handle2" src="../../assets/mobile/index-handle1.png" alt="">
					<div class="words">{{handleWord}}</div>
				</div>
			</div>
		</div>
		<!-- 底部 -->
		<div class="footer">
			<div class="follow">
				<div class="QQ-block">
					<img src="../../assets/mobile/follow-QQ.png" alt="">
					<span>{{QQ}}</span>
				</div>
				<img @click="wechatShow=true" class="follow-item" src="../../assets/mobile/follow-wechart.png" alt="">
				<img @click="goWeibo" class="follow-item" src="../../assets/mobile/follow-sina.png" alt="">
			</div>
			<!-- 微信二维码 -->
			<div v-if="wechatShow" @click="wechatShow=false" class="video-block">
				<img style="height: 30vh;" :src="wechatPath" :alt="wechatPath">
			</div>
			<img style="width: 80%;" src="../../assets/mobile/split-line.png" alt="">
			<img class="footer-logo" src="../../assets/mobile/footer-logo.png" alt="">
			<div class="word">
				<span style="margin-right: 10px;">家长监护</span>
				<span>适龄提示：本游戏适合18岁（含）以上玩家娱乐</span>
			</div>
			<div class="word">
				<span>互联网ICP备案：<a @click="goPage">沪ICP备13003575-1号</a> | 上海掌梦网络科技有限公司</span>
			</div>
			<div class="word">
				<span>沪公网安备 31011502017186号 | 上海掌梦网络科技有限公司</span>
			</div>
			<div class="word">
				<span style="margin-right: 10px;">地址：上海市浦东新区乳山路233号德必WE402</span>
				<span>客服电话：021-58385528</span>
			</div>
		</div>
		<!-- 视频播放 -->
		<div v-show="videoShow" @click="hideVideo" class="video-block">
			<video
				id="video2"
				:src="videoPath"
				x5-video-player-type='h5'
				x5-video-player-fullscreen='true'
				playsinline
				webkit-playsinline
			></video>
		</div>
		<!-- 背景音乐 -->
		<audio
			autoplay
			loop="loop"
			:src="voicePath"
			id="bg_voice"
		>您的浏览器不支持 audio 标签。</audio>
	</div>
</template>

<script>
export default {
	name: 'MIndex',
	data() {
		return {
			voicePath: require('../../assets/background-voice.mp3'),
			imageOrVideo: '2',
			indexBg: null,
			videoPath: null,
			videoShow: false,
			handleWord: '',
			handleUrl: '',
			wechatShow: false,
			wechatPath: '',
			weiboPath: '',
			QQ: '',
			indexLogo: null,
			showVideoBtn: false,
		}
	},
	mounted() {
		const width = document.body.clientWidth;
		if(width > 850) {
			this.$router.push({name: 'p-index'});
		} else {
			this.init();
		}

		document.addEventListener('visibilitychange', function () {
			if (document.visibilityState === 'hidden') {
				document.getElementById("bg_voice").pause();
			}
			// 用户打开或回到页面
			if (document.visibilityState === 'visible') {
				document.getElementById("bg_voice").play();
			}
		});
	},
	methods: {
		init() {
			this.$http.get('/api/website/getIndexInfo?platform=2').then(res => {
				// 背景
				this.imageOrVideo = res.result.imageOrVideo;
				this.indexBg = res.result.indexImageVideo.filePath;
				// 视频
				this.videoPath = res.result.indexVideo.filePath;
				// 预约功能
				this.handleWord = res.result.indexSuspend.isValue;
				this.handleUrl = res.result.indexSuspend.isUrl;
				// 微信二维码
				this.wechatPath = res.result.weixin.filePath;
				// 微博链接
				this.weiboPath = res.result.microblog.weibo;
				this.QQ = res.result.qq[0].qq;
				// 首页logo
				this.indexLogo = res.result.indexLogo.filePath;
				// 是否显示按钮
				this.showVideoBtn = res.result.wasShowButton === '1';
			});
		},
		goHandle() {
			window.open(this.handleUrl, '_blank');
		},
		goWeibo() {
			window.open(this.weiboPath, '_blank');
		},
		showVideo() {
			this.videoShow = true;
			document.getElementById("video2").play();
			document.getElementById("bg_voice").pause();
		},
		hideVideo() {
			this.videoShow = false;
			document.getElementById("video2").pause();
			document.getElementById("bg_voice").play();
		},
		goPage() {
			window.open('https://beian.miit.gov.cn/', '_blank')
		}
	}
}
</script>
